import React from "react";
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap";
import { Formik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { addDeliverable } from "../../../api/deliverable";
import useCustomValidation from "../validationSchema";

const AddDeliverable = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { dealId } = useParams();
    const { deliverableSchema } = useCustomValidation();

    const { setData, loading, error, success } = useResponse(
        (data) => addDeliverable(data, dealId),
        () => navigate(`/deals/show/${dealId}`)
    );

    const initialValues = {
        timeline: "",
        deliverable: "",
        notes: "",
    };

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Add")} ${t("Deliverable")}`} />

                <Formik
                    initialValues={initialValues}
                    validationSchema={deliverableSchema}
                    onSubmit={(values) => {
                        setData({ data: values, type: "add" });
                    }}
                >
                    {(formik) => (
                        <Form
                            className="needs-validation"
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                            }}
                        >
                            <FormGroup className="mb-3">
                                <Label for="timeline">{t("Timeline")}</Label>
                                <Input
                                    id="timeline"
                                    name="timeline"
                                    type="date"
                                    placeholder={t("Select date")}
                                    value={formik.values.timeline}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.timeline && !!formik.errors.timeline}
                                    min={new Date().toISOString().split("T")[0]}
                                />
                                <FormFeedback>{formik.errors.timeline}</FormFeedback>
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <Label for="deliverable">{t("Deliverable")}</Label>
                                <Input
                                    id="deliverable"
                                    name="deliverable"
                                    type="text"
                                    placeholder={t("Enter deliverable")}
                                    value={formik.values.deliverable}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.deliverable && !!formik.errors.deliverable}
                                />
                                <FormFeedback>{formik.errors.deliverable}</FormFeedback>
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <Label for="notes">{t("Notes")}</Label>
                                <Input
                                    id="notes"
                                    name="notes"
                                    type="textarea"
                                    placeholder={t("Enter notes")}
                                    value={formik.values.notes}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.notes && !!formik.errors.notes}
                                    rows="4"
                                />
                                <FormFeedback>{formik.errors.notes}</FormFeedback>
                            </FormGroup>

                            <FormButtonHandler btnTxt={t("Add")} loading={loading} />

                            <ResultHandler
                                error={error}
                                success={success}
                                successMsg={t("Created Successfully!")}
                            />
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    );
};

export default AddDeliverable;
